export default {
  "languageSwitcher": {
    "label": "Language",
    "english": "English",
    "spanish": "Español"
  },
  "phoneInput": {
    "mobilePhoneLabel": "Mobile Phone",
    "countryFlagAlt": "United States"
  },
  "select": {
    "requiredError": "This field is required",
    "statePlaceholder": "-- Select your state --"
  },
  "progressBar": {
    "percentComplete": "{{percent}}% Complete",
    "advertiserDisclosures": "Advertiser Disclosures",
    "goBack": "Go back"
  },
  "applicationProgress": {
    "heading": "Application Status",
    "stageOf": "Stage {{current}} of {{total}}",
    "complete": "Complete",
    "stages": {
      "assigned": {
        "label": "Application Assigned",
        "description": "Your application has been assigned to a loan specialist"
      },
      "reviewing": {
        "label": "Under Review",
        "description": "We are reviewing your information"
      },
      "ready": {
        "label": "Results Ready",
        "description": "Your loan results are ready"
      },
      "contact": {
        "label": "Contact Attempted",
        "description": "Our team is trying to reach you"
      }
    }
  },
  "footer": {
    "legalLinks": {
      "privacyPolicy": "Privacy Policy",
      "termsOfUse": "Terms of Use",
      "caPrivacyPolicy": "CA Privacy Policy",
      "optOut": "Opt Out",
      "eCommConsent": "E-Comm Consent",
      "privacyNotice": "Privacy Notice"
    },
    "logoAlt": "Symple Lending",
    "socialLabels": {
      "facebook": "Facebook",
      "x": "X",
      "instagram": "Instagram",
      "linkedin": "LinkedIn",
      "tiktok": "TikTok"
    },
    "copyright": "© {{year}} Symple Lending, LLC. All rights reserved. <nmlsLink>NMLS #2508833</nmlsLink>",
    "disclosure": "Symple Lending, LLC is a Utah licensed lender under the Utah Department of Financial Institutions (<nmlsLink>NMLS #2508833</nmlsLink>). Personal loan offers provided to customers who originated via a paid Google or Bing advertisement feature rate quotes on Symple Lending of no greater than 35.99% APR with terms from 61 days to 180 months. Your actual rate depends upon credit score, loan amount, loan term, domicile and credit usage and history, and will be agreed upon between you and the lender. An example of total amount paid on a personal loan of $10,000 for a term of 36 months at a rate of 10% would be equivalent to $11,616.12 over the 36 month life of the loan.",
    "equalHousingAlt": "Equal Housing Lender",
    "partnersIntro": "Symple Lending's <partnersLink>Partners</partnersLink> Licensing Information:",
    "partnerAchieve": "Achieve Personal Loans (<nmls227977>NMLS #227977</nmls227977>), HELOC from Achieve Loans (<nmls1810501>NMLS # 1810501</nmls1810501>).",
    "partnerMoneyLion": "ML Enterprise Inc., a.k.a. Engine by MoneyLion, (<nmls1475872>NMLS #1475872</nmls1475872>)"
  },
  "disclaimer": {
    "consent": "All website interactions and phone calls are recorded for marketing, compliance and quality assurance purposes. By clicking the button above or by using this website, you accept and agree to our <termsLink>Terms and Conditions</termsLink>, <esignLink>e-Sign</esignLink>, <arbitrationLink>Arbitration Agreement</arbitrationLink> and <privacyLink>Privacy Policy</privacyLink>, including the provisions regarding accepting or avoiding cookies."
  },
  "disclosureModal": {
    "title": "Advertiser Disclosures",
    "closeLabel": "Close",
    "paragraph1": "Symple Lending is not a lender and we do not offer financial products directly. Symple Lending does not represent the Financial Institution Providers on our platform other than as a referral source and we do not endorse or recommend particular Financial Institution Providers or products. Symple Lending does not accept applications, make credit decisions, or guarantee a particular result from a financial product offer request. Any Financial Institution Provider will require you to submit an application to them for their consideration before extending an offer of credit. We do not issue loan approvals, loan commitments, or make any guarantees on behalf of any Financial Institution Provider and all rates, fees, and terms are presented without guarantee. Rates, fees, and terms are subject to change pursuant to each Financial Institution Provider's discretion and may not be available in all states or for all types of financial products. You may receive loan offers that vary in amount from what you requested. We may also show offers for financial products that vary from the type you requested, such as debt relief, debt settlement, credit repair, or credit monitoring. Financial Institution Providers' privacy policies and/or security practices may differ from those of Symple Lending.",
    "paragraph2": "We do not connect you with every Financial Institution Provider in the market, so other Financial Institutions and financial products not listed on our platform may be available to you, subject to different terms and conditions, including lower rates. We cannot guarantee the lowest price or best terms available in the market. Your personal financial situation is unique, and it is your responsibility to evaluate the information and content provided before making any financial decisions.",
    "paragraph3": "We support the principles of the federal Equal Credit Opportunity Act (the \"ECOA\"). We do not engage in business practices that discriminate on the basis of race, color, religion, national origin, sex, marital status, age (provided the applicant has the capacity to contract), the fact that all or part of the applicant's income derives from a public assistance program, or the fact that the applicant has in good faith exercised any right under the Consumer Credit Protection Act. Similarly, we are committed to compliance with any applicable state and local anti-discrimination laws."
  },
  "emailVerificationModal": {
    "title": "Verify Your Email",
    "description": "We need your email address to complete your application.",
    "submit": "Continue with this email",
    "submitting": "Submitting..."
  },
  "loadingOverlay": {
    "processing": "Processing..."
  },
  "echelonProgress": {
    "title": "Processing your application",
    "subtitle": "This may take 1–2 minutes. Please keep this page open.",
    "done": "Done",
    "steps": {
      "starting": {
        "label": "Verifying your eligibility",
        "description": "Checking your details against our criteria"
      },
      "processing": {
        "label": "Connecting with solution specialists",
        "description": "Your application is being assigned to our team"
      },
      "reviewing": {
        "label": "Reviewing your application",
        "description": "Analysing your profile and available options"
      },
      "finalizing": {
        "label": "Preparing your personalised options",
        "description": "Almost there — compiling your results"
      }
    }
  },
  "button": {
    "loadingDefault": "Loading..."
  },
  "securityTiles": {
    "sslTitle": "256-bit SSL",
    "sslDescription": "Secure & Encrypted",
    "privacyTitle": "Privacy First",
    "privacyDescription": "Your Data is Protected",
    "speedTitle": "Fast & Easy",
    "speedDescription": "2-Minute Application"
  },
  "tryAnotherWay": {
    "prompt": "Try a different verification method:",
    "smsCode": "Verify with SMS Code",
    "securityQuestions": "Verify with Security Questions",
    "offerCode": "Verify with Offer Code"
  },
  "applicationFlow": {
    "loading": {
      "offers": "Loading your offers...",
      "personalizedDetails": "Loading your personalised details...",
      "application": "Loading your application...",
      "secureConnection": "Creating secure connection...",
      "verifyingSmsCode": "Verifying SMS code...",
      "checkingEligibility": "Checking eligibility...",
      "sendingNewCode": "Sending new code...",
      "verifyingInformation": "Verifying your information...",
      "verifyingIdentity": "Verifying your identity...",
      "submittingAnswers": "Submitting your answers...",
      "submittingApplication": "Submitting application..."
    },
    "errors": {
      "genericError": "An error occurred",
      "failedToCreateConnection": "Failed to create connection",
      "noSecurityQuestions": "No security questions received",
      "failedToStartIdentityVerification": "Failed to start identity verification",
      "identityVerificationFailed": "Identity verification failed",
      "unableToVerifyIdentity": "We were unable to verify your identity. Please try a different method.",
      "verificationFailedCheckDetails": "Verification failed. Please check your details and try again.",
      "failedToSendNewCode": "Failed to send new code",
      "failedToConnectCall": "Failed to connect call. Please try again.",
      "sessionExpired": "Your session has expired or could not be continued. Please start again."
    }
  },
  "phoneDialer": {
    "outsideHoursTitle": "Outside of Calling Hours",
    "outsideHoursDescription": "Due to TCPA regulations, we can only call between 8 AM and 8 PM local time.",
    "nextAvailableTime": "Next available time: {{time}}",
    "callErrorTitle": "An error occurred while connecting your call.",
    "callErrorSubtitle": "Please call us directly using the number below",
    "callMeNow": "Call Me Now",
    "callUnableToConnect": "Unable to connect your call. Please use the number below to call us directly.",
    "callConnectionFailed": "Connection failed. Please use the number below to call us directly.",
    "callAutoConnectFailed": "Unable to connect automatically. Please use the number below to call us directly.",
    "connectingTitle": "Connecting Your Call",
    "connectingSubtitle": "To discuss your loan application",
    "secondsLabel": "seconds",
    "incomingCallFrom": "Incoming call from:"
  }
} as const;
